import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选暴走黑料与黑料社深度专题推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-xl overflow-hidden cursor-pointer aspect-[4/3]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="inline-block px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-semibold rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <p className="text-xs md:text-sm text-background-50/70 mb-1">
                  {item.subtitle}
                </p>
                <h3 className="text-base md:text-lg font-heading font-bold text-background-50 leading-snug">
                  {item.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}